var SHARE_LINKS = {
  facebook: 'https://www.facebook.com/sharer/sharer.php?u=',
  twitter: 'https://twitter.com/share?url=',
  linkedin: 'https://www.linkedin.com/shareArticle?mini=true&url='
};
var shareOnSocialNetwork = function shareOnSocialNetwork(_ref) {
  var socialNetwork = _ref.socialNetwork,
    url = _ref.url,
    shareUrl = _ref.shareUrl;
  var shareLink = socialNetwork && url ? "".concat(SHARE_LINKS[socialNetwork]).concat(url) : shareUrl;
  if (shareLink) {
    window.open(shareLink, '_blank', 'toolbar=no, scrollbars=yes, resizable=yes, top=400, left=400, width=700, height=500');
  }
};
export default shareOnSocialNetwork;